import { render, staticRenderFns } from "./UserEditBody.vue?vue&type=template&id=77350f22&scoped=true"
import script from "./UserEditBody.vue?vue&type=script&lang=js"
export * from "./UserEditBody.vue?vue&type=script&lang=js"
import style0 from "./UserEditBody.vue?vue&type=style&index=0&id=77350f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77350f22",
  null
  
)

export default component.exports